/**
 * KOMTO bundle add-ons.
 *
 * Adds the checked accessories to the cart, then lets the theme's own product form
 * run its normal add-to-cart. We intercept in the capture phase so we go first, and
 * re-submit with a pass-through flag so the theme handles the second event untouched.
 */
class KomtoBundleAddons extends HTMLElement {
  connectedCallback() {
    const formId = this.dataset.formId;
    this.form =
      (formId && document.getElementById(formId)) ||
      document.querySelector('.js-product-form-main');
    if (!this.form) return;

    this.errorBox = this.querySelector('.komto-bundle__error');
    this.passthrough = false;
    this.onSubmit = this.onSubmit.bind(this);
    this.form.addEventListener('submit', this.onSubmit, true);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit, true);
  }

  selectedItems() {
    return [...this.querySelectorAll('.komto-bundle__check')]
      .filter((input) => input.checked && !input.disabled)
      .map((input) => ({ id: Number(input.dataset.addonVariantId), quantity: 1 }));
  }

  showError() {
    if (!this.errorBox) return;
    this.errorBox.textContent = this.dataset.error || '';
    this.errorBox.hidden = false;
  }

  async onSubmit(event) {
    if (this.passthrough) {
      this.passthrough = false;
      return;
    }
    const items = this.selectedItems();
    if (!items.length) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const submitter = event.submitter || this.form.querySelector('[name="add"]');
    if (this.errorBox) this.errorBox.hidden = true;

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error(`cart/add.js ${response.status}`);
      this.querySelectorAll('.komto-bundle__check').forEach((input) => {
        input.checked = false;
      });
    } catch (error) {
      // The main product must still reach the cart even if an add-on fails.
      console.warn('KOMTO bundle add-ons:', error);
      this.showError();
    }

    this.passthrough = true;
    if (typeof this.form.requestSubmit === 'function') {
      this.form.requestSubmit(submitter);
    } else {
      this.form.submit();
    }
  }
}

if (!customElements.get('komto-bundle-addons')) {
  customElements.define('komto-bundle-addons', KomtoBundleAddons);
}
